module.exports = function (settingsService, dialogRegistry) {
    return {
        restrict: 'E',
        scope: {
            dialogName: '@',
            settingGroup: '@?',
            settingName: '@?',
            message: '@?',
            onDismiss: '&?',
        },
        template: require('./dialog.directive.html').trim(),
        link(scope) {
            if (scope.settingGroup && scope.settingName) {
                settingsService.getSettingValue(scope.settingGroup, scope.settingName).then((response) => {
                    scope.dialogMessage = response;
                });
            } else {
                scope.dialogMessage = scope.message || '';
            }

            scope.settingDialog = dialogRegistry.getDialog(scope.dialogName);
            if (scope.settingDialog) {
                scope.settingDialog.show();
            }

            scope.closeDialog = function () {
                if (scope.settingDialog) {
                    scope.settingDialog.close();
                    if (scope.onDismiss) {
                        scope.onDismiss();
                    }
                }
            };
        },
    };
};



// WEBPACK FOOTER //
// ./src/common/dialog/dialog.directive.js